export default __webpack_public_path__ + "static/media/Sig1.653d05cb.png";